export const id_role_teacher = 1;
export const id_role_student = 2;
export const id_role_dekanat = 3;
export const access_dekanat = 1;
